import _ from "lodash";
import inject from "scripts/ioc/inject";
import BaseGrowlAlertView from "scripts/views/baseGrowlAlertView";
import templateSessionRefreshGrowlAlert from "templates/refreshSessionGrowlAlert.hbs";

import { fetchSubjectFromSecurity } from "scripts/utils/fetchSecurity";

class RefreshSessionAlertView extends BaseGrowlAlertView {
  constructor(options, securityService = inject("securityService")) {
    super(options);
    this.securityService = securityService;
  }

  get template() {
    return templateSessionRefreshGrowlAlert;
  }

  get events() {
    return _.extend({}, super.events, {
      "click #bb-app-update-growl-alert-refresh-button": "onClickRefresh",
    });
  }

  render() {
    this.$el.html(this.template());

    this.animateIn();

    return this;
  }

  onClickRefresh() {
    Promise.resolve(
      fetchSubjectFromSecurity({
        token: this.securityService.getUser().getToken(),
      }),
    )
      .then(() => this.animateOut())
      .catch(() => window.location.reload());
    return false;
  }
}

export default RefreshSessionAlertView;
